import React from 'react';
import { BookOpenIcon, CalendarIcon, CheckSquareIcon, ShoppingCartIcon, UtensilsIcon, ClockIcon } from 'lucide-react';
export function Includes() {
  const items = [{
    icon: BookOpenIcon,
    title: 'Ebook PDF Completo',
    desc: 'La guía paso a paso con toda la teoría y práctica.'
  }, {
    icon: CalendarIcon,
    title: 'Calendario 21 Días',
    desc: 'Formato imprimible para marcar tu progreso diario.'
  }, {
    icon: CheckSquareIcon,
    title: 'Checklist AM/PM',
    desc: 'Tu rutina diaria simplificada en una hoja.'
  }, {
    icon: ShoppingCartIcon,
    title: 'Listas de Compras',
    desc: 'Organizadas por semana para que no compres de más.'
  }, {
    icon: UtensilsIcon,
    title: 'Recetario Rápido',
    desc: 'Plantillas de platos y recetas que no te esclavizan.'
  }, {
    icon: ClockIcon,
    title: 'Plan Rescate 48h',
    desc: '¿Comiste mal el fin de semana? Usa esto para volver.'
  }];
  return <section className="py-16 md:py-24 bg-stone-900 text-white" data-id="element-101">
      <div className="container mx-auto px-4" data-id="element-102">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-103">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-104">
            Todo lo que recibes hoy
          </h2>
          <p className="text-lg text-stone-300" data-id="element-105">
            Herramientas diseñadas para que no tengas que pensar, solo ejecutar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-106">
          {items.map((item, index) => <div key={index} className="flex items-start p-4 rounded-xl hover:bg-stone-800 transition-colors" data-id="element-107">
              <item.icon className="h-8 w-8 text-emerald-400 mr-4 flex-shrink-0" data-id="element-108" />
              <div data-id="element-109">
                <h3 className="font-bold text-lg mb-1" data-id="element-110">{item.title}</h3>
                <p className="text-stone-400 text-sm leading-relaxed" data-id="element-111">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}